import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { FormattedMessage } from 'react-intl';

const RenderValue = ({ year }: { year: Number }) => {
  if (year === 0) {
    return (
      <span>
        <FormattedMessage id="common.less.than.a.year" />
      </span>
    );
  } else if (year > 0) {
    return (
      <span>
        <FormattedMessage
          id="common.assetAge.years"
          values={{ assetAgeName: year }}
        />
      </span>
    );
  } else {
    return <DisabledTag>NA</DisabledTag>;
  }
};

export default RenderValue;
